import {MemberShipConfig, LoginConfig} from '@/store/Constraints';
import {Axios} from '@/api/Axios';
import {MemberApi} from '@/api/Api';

const MemberShipStore = {
  state: {
    memberShipInfo: {
      id: '',
      pw: '',
      pwConfirm: '',
      snsChannel: '',
      snsId: '',
      name: '',
      nickname: '',
      gender: '',
      mobile: '',
      birth: '',
      ci: '',
      di: '',
      termsAgree: 'N',
      privateAgree: 'N',
      optionalInfoAgree: 'N',
      positionAgree: 'N',
      infoPushAgree: 'Y',
      marketingSMSAgree: 'N',
      marketingPushAgree: 'N',
      marketingEmailAgree: 'N'
    },
    agreeResult: false,
    checkEmail: false,
    checkNickname: false,
  },
  getters: {
    [MemberShipConfig.GET_INFO]: (state) => state.memberShipInfo,
    [MemberShipConfig.GET_CHECK_ID]: (state) => state.checkEmail,
    [MemberShipConfig.GET_CHECK_NICKNAME]: (state) => state.checkNickname,
    [MemberShipConfig.GET_AGREE_RESULT]: (state) => state.agreeResult,
  },
  mutations: {
    [MemberShipConfig.CHECK_ID]: (state, payload) => {
      state.checkEmail = payload.checked;
    },
    [MemberShipConfig.CHECK_NICKNAME]: (state, payload) => {
      state.checkNickname = payload.checked;
    },
    [MemberShipConfig.AGREE_ALL]: (state, payload) => {
      state.memberShipInfo.name = payload.name;
      state.memberShipInfo.mobile = payload.mobile;
      state.memberShipInfo.birth = payload.birth;
      state.memberShipInfo.gender = payload.gender;
      state.memberShipInfo.ci = payload.ci;
      state.memberShipInfo.di = payload.di;
      state.agreeResult = true;
    },
    [MemberShipConfig.CLEAR_AGREE_INFO]: (state, payload) => {
      state.memberShipInfo.termsAgree = "N";
      state.memberShipInfo.privateAgree = "N";
      state.memberShipInfo.optionalInfoAgree = "N";
      state.memberShipInfo.positionAgree = "N";
      state.memberShipInfo.infoPushAgree = "N";
      state.memberShipInfo.marketingSMSAgree = "N";
      state.memberShipInfo.marketingPushAgree = "N";
      state.memberShipInfo.marketingEmailAgree = "N";
    },
    [MemberShipConfig.CLEAR_USER_INFO]: (state, payload) => {
      state.memberShipInfo.id = "";
      state.memberShipInfo.pw = "";
      state.memberShipInfo.pwConfirm = "";
      state.memberShipInfo.snsChannel = "";
      state.memberShipInfo.snsId = "";
      state.memberShipInfo.name = "";
      state.memberShipInfo.nickname = "";
      state.memberShipInfo.gender = "";
      state.memberShipInfo.mobile = "";
      state.memberShipInfo.birth = "";
      state.memberShipInfo.ci = "";
      state.memberShipInfo.di = "";
      state.agreeResult = false;
      state.agreeResult = false;
      state.agreeResult = false;
    },
  },
  actions: {
    [MemberShipConfig.CHECK_ID]: (store, payload) => {
      return new Promise((resolve, reject) => {
        Axios.post(MemberApi.ID_CHECK, payload)
          .then(res => {
            store.commit(MemberShipConfig.CHECK_ID, {checked: res.code === "0000"});
            resolve(res);
          })
          .catch(err => {
            console.error(err);
            store.commit(MemberShipConfig.CHECK_ID, {checked: false});
            reject(err);
          })
      });
    },
    [MemberShipConfig.CHECK_NICKNAME]: (store, payload) => {
      return new Promise((resolve, reject) => {
        Axios.post(MemberApi.NICKNAME_CHECK, payload)
          .then(res => {
            store.commit(MemberShipConfig.CHECK_NICKNAME, {checked: res.code === "0000"});
            resolve(res);
          })
          .catch(err => {
            console.error(err);
            store.commit(MemberShipConfig.CHECK_NICKNAME, {checked: false});
            reject(err);
          })
      });
    },
    [MemberShipConfig.AGREE_ALL]: (store, payload) => {
      store.commit(MemberShipConfig.AGREE_ALL, payload);
    }
  }
}
export default MemberShipStore;



// WEBPACK FOOTER //
// ./src/store/member/MemberShipStore.js